import { useState } from 'react';
import { SurveyConfirmation } from './SurveyConfirmation';
import { SurveyForm } from './SurveyForm';

export const PerspectiveSurveySection = () => {
  const [submitted, setSubmitted] = useState(false);

  return (
    <section id='perspective' className='py-14 pb-24 text-center bg-white'>
      <div className='container mx-auto px-8 max-w-[1120px]'>
        <p className='text-base font-bold uppercase tracking-widest text-brand-500 mb-3'>
          Your impact
        </p>
        <h2 className='text-display-md font-bold text-gray-700 tracking-tight mb-4'>
          Help build the next phase
        </h2>
        <p className='text-lg text-gray-500 max-w-[48ch] mx-auto mb-16'>
          We&rsquo;re redesigning this experience around your goals. Answer a few quick questions
          to directly influence what we offer.
        </p>

        {submitted ?
          <SurveyConfirmation />
        : <SurveyForm onSubmitSuccess={() => setSubmitted(true)} />}
      </div>
    </section>
  );
};
